export default "__VITE_ASSET__DJgp6gQR__"